import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AgentProvider } from './contexts/AgentContext';
import { Layout } from './components/Layout';
// Import pages
import { AIMapPage } from './pages/AIMapPage';
import { GovernancePage } from './pages/GovernancePage';
import { PolicyPage } from './pages/PolicyPage';
import { AuditTrailPage } from './pages/AuditTrailPage';
import { AIActPage } from './pages/AIActPage';
import { GDPRPage } from './pages/GDPRPage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { ServizioDetailPage } from './pages/ServizioDetailPage';
import { CostManagementPage } from './pages/CostManagementPage';
import { CostManagementDetailPage } from './pages/CostManagementDetailPage';
import { GreenOpsPage } from './pages/GreenOpsPage';
import { ReportPage } from './pages/ReportPage';
import { ProvidersPage } from './pages/ProvidersPage';
import { ProviderDetailPage } from './pages/ProviderDetailPage';
import { FornitoriPage } from './pages/FornitoriPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3mlj9mx3nbh44">
      <AgentProvider data-id="element-1" data-mp="3ml13n8r6loj0">
        <Routes data-id="element-2" data-mp="3mkhnnxl3da7m">
          <Route path="/" element={<Layout data-id="element-4" data-mp="3mj6ipufwtwex" />} data-id="element-3" data-mp="3mjztr7lwj82v">
            {/* Redirect root to costs (Overview) */}
            <Route index element={<Navigate to="/costs" replace data-id="element-6" data-mp="3relumgucxi8p" />} data-id="element-5" data-mp="3rd1bdndhtlq5" />
            {/* Main Routes */}
            <Route path="canvas" element={<AIMapPage data-id="element-8" data-mp="2zl3azit8d249" />} data-id="element-7" data-mp="56n1goet9nj" />
            <Route path="servizio/:agentId" element={<ServizioDetailPage data-id="element-10" data-mp="2zmwguvw0rib7" />} data-id="element-9" data-mp="2zlv6yuqqp1v2" />
            <Route path="costs" element={<CostManagementPage data-id="element-12" data-mp="33nq73vwxp979" />} data-id="element-11" data-mp="33mf2jtvnzxf3" />
            <Route path="cost-management" element={<CostManagementDetailPage data-id="element-14" data-mp="38l8hzruihyhw" />} data-id="element-13" data-mp="33orhrza1ftog" />
            <Route path="greenops" element={<GreenOpsPage data-id="element-16" data-mp="38o4f5dyjcj5a" />} data-id="element-15" data-mp="38k6vmr81ppkv" />
            <Route path="reports" element={<ReportPage data-id="element-18" data-mp="3dmfprqwnmxok" />} data-id="element-17" data-mp="3dl4mrtb19tyi" />
            <Route path="providers" element={<ProvidersPage data-id="element-20" data-mp="nw2cw89b1us5" />} data-id="element-19" data-mp="3dii4aymltu1i" />
            <Route path="providers/:id" element={<ProviderDetailPage data-id="element-22" data-mp="nxwv3et6z8sj" />} data-id="element-21" data-mp="nuraabrlit2m" />
            <Route path="users" element={<FornitoriPage data-id="element-24" data-mp="st2iyj65mxj9" />} data-id="element-23" data-mp="stuczpk3sn7f" />

            {/* Compliance Routes with Submenu */}
            <Route path="compliance" data-id="element-25" data-mp="356tf9929ob6">
              <Route index element={<Navigate to="/compliance/ai-act" replace data-id="element-27" data-mp="3ud1glcmeruc7" />} data-id="element-26" data-mp="38b5essrpoce" />
              <Route path="ai-act" element={<AIActPage data-id="element-29" data-mp="d4nvlgp3tk2e" />} data-id="element-28" data-mp="3ucjdbw1bwfus" />
              <Route path="gdpr" element={<GDPRPage data-id="element-31" data-mp="d45ti3frgbmk" />} data-id="element-30" data-mp="d4xq9hl3gfef" />
              <Route path="audit" element={<AuditTrailPage hideHeader={false} data-id="element-33" data-mp="851m9icecnyv" />} data-id="element-32" data-mp="d2bhjemgvtum" />
            </Route>

            <Route path="impostazioni" element={<ImpostazioniPage data-id="element-35" data-mp="3gklce8hrtq9p" />} data-id="element-34" data-mp="3gle7gc7darc0" />
            {/* Catch all - redirect to costs (Overview) */}
            <Route path="*" element={<Navigate to="/costs" replace data-id="element-37" data-mp="3bnuurgqbimm6" />} data-id="element-36" data-mp="3bn2z65wq0ovw" />
          </Route>
        </Routes>
      </AgentProvider>
    </BrowserRouter>;
}